export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9917.75592f5a.jpg";